export class FeaturedCollectionAccordion extends HTMLElement {
  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 0);
  }

  init() {
    this.accordions = this.querySelectorAll("accordion-custom");
    const section = this.closest(".featured-collection-section");
    this.imageWrappers = section
      ? section.querySelectorAll(".featured-collection__image-wrapper")
      : [];

    this.accordions.forEach((accordion) => {
      const header = accordion.querySelector(".details__header");

      // Set initial open accordion and show its image
      if (accordion.hasAttribute("open")) {
        this.currentOpenAccordion = accordion;
        this.showImage(accordion.dataset.index);
      }

      header.addEventListener("click", () => {
        const isOpen = accordion.hasAttribute("open");

        // If clicked item is already open, do nothing (Always Keep One Open)
        if (isOpen && this.currentOpenAccordion === accordion) {
          return;
        }

        // Close others and open this one
        this.closeOthers(accordion);
        accordion.setAttribute("open", "");
        this.currentOpenAccordion = accordion;
        this.showImage(accordion.dataset.index);
      });
    });

    // Theme editor integration
    document.addEventListener("shopify:block:select", (event) => {
      const accordion = event.target.closest("accordion-custom");
      if (accordion && this.contains(accordion)) {
        this.closeOthers(accordion);
        accordion.setAttribute("open", "");
        this.showImage(accordion.dataset.index);
      }
    });
  }

  closeOthers(openAccordion) {
    this.accordions.forEach((accordion) => {
      if (accordion !== openAccordion) {
        accordion.removeAttribute("open");
      }
    });
  }

  showImage(index) {
    if (!this.imageWrappers.length) return;

    this.imageWrappers.forEach((wrapper) => {
      if (wrapper.dataset.imageIndex === index) {
        wrapper.style.opacity = "1";
        wrapper.style.zIndex = "10";
      } else {
        wrapper.style.opacity = "0";
        wrapper.style.zIndex = "0";
      }
    });
  }
}

if (!customElements.get("featured-collection-accordion")) {
  customElements.define(
    "featured-collection-accordion",
    FeaturedCollectionAccordion,
  );
}
